<template>
  <Loader :value="promises.fetch" class="account-settings-loader">
    <div class="account-settings container">
      <Card :title="$t('shopShort', 1)" class="account-settings__shop">
        <template #default>
          <div class="account-settings__shop-items">
            <ContractUpload
              v-model="data.shop.contractTemplate"
              :label="$t('shopContract')"
              data-field="contractTemplate"
              sample="/api/shop/contract-template/cover"
            />
            <InputComponent
              :label="$t('settings:shop-hideDefaultOnContract')"
              :sublabel="$t('settings:shop-hideDefaultOnContract:sublabel')"
              data-field="hideDefaultOnContract"
            >
              <Radio
                v-model="data.shop.hideDefaultOnContract"
                class="elder-input__element"
                :items="[
                  { value: false, label: $t('yes') },
                  { value: true, label: $t('no') },
                ]"
              />
            </InputComponent>
          </div>
        </template>
      </Card>
    </div>
    <ButtonComponent
      :icon="['fal', 'angle-right']"
      :label="$t('save')"
      :success-label="$t('saved')"
      :loading-label="$t('saving')"
      :promise="promises.mutate"
      @click="submit"
      theme="primary"
      class="account-settings__submit"
    />
  </Loader>
</template>

<script>
import { i18n } from '@/i18n'
import Store from '@/store'
import { mapState, mapActions } from 'vuex'
import ModelMixin from '@/mixins/Model'

import Radio from '@kvass/radio'
import Card from '@/components/Card'
import ContractUpload from '@/components/Contract/TemplateUpload'
import { InputComponent } from 'vue-elder-input'

const meta = {
  skip: !Store.getters.isAdmin && !Store.getters.isOwner,
  order: 4,
  id: 'accountsettings',
  label: i18n.t('accountSettings'),
  icon: ['fal', 'redo'],
}

export { meta }
export default {
  mixins: [
    ModelMixin({
      model: {
        shop: {
          hideDefaultOnContract: true,
          contractTemplate: null,
        },
      },
      guard: true,
    }),
  ],
  props: {
    isActive: Boolean,
  },
  watch: {
    isActive: {
      handler(val) {
        if (!val) return
        return this.fetch([{}, { query: 'AccountSettings' }])
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('AccountSettings', ['item', 'promises']),
  },
  methods: {
    ...mapActions('AccountSettings', ['fetch', 'mutate']),
    submit() {
      return this.mutate([this.getData(), { mutation: 'AccountSettingsUpdate' }])
    },
  },
  components: {
    Card,
    Radio,
    InputComponent,
    ContractUpload,
  },
}
</script>

<style lang="scss">
.account-settings {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 2rem;

  padding-inline: 0;

  &__shop-items {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 1.5rem;
  }

  &__submit {
    margin-top: 2rem;
  }
}
</style>
